//Generated File 
export const BigText = `BigText`;
export const Binary = `Binary`;
export const Boolean = `Boolean`;
export const Color = `Color`;
export const Date = `Date`;
export const DateAndTime = `DateAndTime`;
export const Decimal = `Decimal`;
export const Detail = `Detail`;
export const Email = `Email`;
export const EntityType = `EntityType`;
export const Enum = `Enum`;
export const FeatureID = `FeatureID`;
export const FieldID = `FieldID`;
export const Genericreference = `Genericreference`;
export const ID = `ID`;
export const Integer = `Integer`;
export const LatLng = `LatLng`;
export const Link = `Link`;
export const Long = `Long`;
export const LongToken = `LongToken`;
export const Measures = `Measures`;
export const Password = `Password`;
export const PhoneNumber = `PhoneNumber`;
export const Reference = `Reference`;
export const Text = `Text`;
export const Time = `Time`;
